import { motion } from 'framer-motion'

import { styled } from 'styled-system/jsx'

const Backdrop = styled(motion.div, {
  base: {
    position: 'fixed',
    inset: '0',
    backgroundColor: 'rgba(26, 19, 48, 0.45)',
    zIndex: '105',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingX: '20px',
  },
})

const Card = styled(motion.div, {
  base: {
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    boxShadow: '0 28px 80px -20px rgba(26, 19, 48, 0.32)',
    padding: '24px 28px',
    width: '100%',
    maxWidth: '460px',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
})

const Header = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: '12px',
  },
})

const Title = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '20px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.3px',
  },
})

const Subtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    margin: '0',
  },
})

const HotkeyList = styled('ul', {
  base: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
})

const HotkeyRow = styled('li', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '14px',
  },
})

const KeysWrap = styled('div', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    flexShrink: '0',
  },
})

const Key = styled('kbd', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    color: 'quickpass.inkSoft',
    backgroundColor: 'quickpass.surfaceCool',
    paddingX: '8px',
    paddingY: '3px',
    borderRadius: 'sm',
    border: '1px solid',
    borderColor: '#E5E0F5',
    minWidth: '24px',
    textAlign: 'center',
  },
})

const Description = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.ink',
    flex: '1',
  },
})

const CloseHint = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    color: 'quickpass.inkSoft',
    fontStyle: 'italic',
    textAlign: 'center',
    marginTop: '4px',
  },
})

export {
  Backdrop,
  Card,
  Header,
  Title,
  Subtitle,
  HotkeyList,
  HotkeyRow,
  KeysWrap,
  Key,
  Description,
  CloseHint,
}
